import { mapSagasFromConfigurations } from '../../helpers/sagas';
import { configurations } from './configurations';

function* apiKeySagas() {
  yield mapSagasFromConfigurations('apiKey')(configurations)
}

export default apiKeySagas;


// WEBPACK FOOTER //
// ./src/state/modules/api-key/sagas.js